{
  "title": "Production Label Print",
  "subtitle": "Select an approved production receipt, then an item on it, then print — the label updates automatically as the item changes.",
  "tabs": {
    "print": "Print",
    "reprint": "Reprint"
  },
  "approvedOnly": "Only production receipts that have been approved appear here — labels can't print until a receipt is approved.",
  "selectionCriteria": "Selection Criteria",
  "selectReceipt": "Production Receipt",
  "selectItem": "Item",
  "noItemsOnReceipt": "This production receipt has no lines.",
  "selectTemplate": "Label Template",
  "noTemplatesAvailable": "No templates available for this item — design one in Label Designer.",
  "itemDetails": "Item Details",
  "itemFields": {
    "batchNo": "Batch No",
    "acceptedQty": "Accepted Qty",
    "labelPrintedQty": "Already Printed Qty"
  },
  "configuration": "Print Configuration",
  "labelQuantity": "Quantity",
  "maxQuantityHint": "Up to {{max}} available for this item.",
  "mode": {
    "auto": "Auto",
    "manual": "Manual",
    "autoHint": "Splits the remaining {{total}} units into labels of {{stuffingQty}} each (from this material's Stuffing Qty), with the last label covering the remainder.",
    "autoNoStuffingQty": "No Stuffing Qty (or a Stuffing Qty of 1) is set on this material — printing one label per unit ({{total}} labels).",
    "labelN": "Label {{n}}",
    "addLabel": "Split / Add Label",
    "allocatedOf": "Allocated: {{allocated}} of {{total}}",
    "mismatchHint": "The split must add up to exactly {{total}} before printing."
  },
  "sendingToPrinter": "Preparing...",
  "printLabels": "Print {{count}} Label(s)",
  "canvasPreviewTitle": "Label Preview",
  "selectTemplatePrompt": "Select a production receipt, item, and template to preview the label.",
  "noLabelsToPreview": "Set a valid quantity split above to preview the labels.",
  "sampleMaterial": "Sample Material",
  "history": {
    "title": "Recent Print History",
    "date": "Date",
    "receipt": "Receipt #",
    "material": "Material",
    "template": "Template",
    "quantity": "Qty",
    "printer": "Printer/Station",
    "user": "Printed By"
  },
  "reprint": {
    "selectionCriteria": "Select Receipt & Item",
    "noPrintedReceipts": "No production receipts have any printed labels yet.",
    "noPrintedItems": "No items on this receipt have been printed yet.",
    "noHistory": "No labels have been printed yet for this item.",
    "labelCount": "Labels",
    "reprintButton": "Reprint"
  }
}
